import { memo } from 'react';
import classNames from 'classnames';
import { prefixClass } from 'lib/utils';
import NTHeader from '../NTHeader';

interface NTDrawHeaderProps {
  columnIndex: number;
  fixed?: boolean;
  data: { name: string; data: any; type: string } | any;
  isDifferenceColumn?: boolean;
}

const NTDrawHeader = memo<NTDrawHeaderProps>(
  ({ columnIndex, fixed = false, data, isDifferenceColumn = false }) => {
    const prefix = prefixClass('nt-layout-column');
    return (
      <div
        className={classNames(prefix(), {
          fixed: fixed,
          'header-column': true,
          'first-column': columnIndex === 0,
          live: data.liveReport && columnIndex !== 0,
          'difference-column': isDifferenceColumn,
        })}
      >
        <NTHeader key={`${data.name || columnIndex}`} headerData={data} columnID={columnIndex} />
      </div>
    );
  },
  // Custom equality check - only re-render if data or columnIndex actually changed
  (prevProps, nextProps) => {
    return (
      prevProps.columnIndex === nextProps.columnIndex &&
      prevProps.fixed === nextProps.fixed &&
      prevProps.data === nextProps.data &&
      prevProps.isDifferenceColumn === nextProps.isDifferenceColumn
    );
  }
);

NTDrawHeader.displayName = 'NTDrawHeader';

export default NTDrawHeader;
